const softAnimations = () => {
    const blocks = [...document.querySelectorAll('.js-section-img-banner')];
    let prev = new Array(blocks.length);
    const max = 1.4;

    $(window).scroll(function () {

        let scroll = $(window).scrollTop(),
            windowBot = scroll + $(window).height();

        blocks.forEach((el, index) => {
            let offset = $(el).position().top,
            diff = windowBot - offset;

            if(diff > 0) {
               let scale = 1 + (diff / 100) / 50 ;
                scale = scale < max ? scale : max;

                const image = el.querySelector('img');

                if (prev[index] !== scale) {
                    image.style.transform = `scale3d(${scale}, ${scale}, ${scale})`;
                    prev = scale;
                }
            }
        })

    });
    $(window).trigger('scroll')
}
export default softAnimations;